import classNames from "classnames";

import { DComponent } from "../../../DComponent";
import { defer } from "../../../../utils/script";
import Env from "../../../../environments";
import { devLog } from "../../../../utils/log";

export default class AuthApple extends DComponent {
  constructor({
    parent,
    id,
    onSubmit = () => { },
    onError = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AuthApple"),
    });
    this.onSubmit = onSubmit;
    this.onError = onError;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AuthApple");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    defer(() => window.AppleID?.auth, () => {
      window.AppleID.auth.init({
        clientId: Env.DUTY_CAST_APPLE_CLIEND_ID,
        scope: 'name email',
        redirectURI: Env.DUTY_CAST_APPLE_REDIRECT_URL,
        // state: '[STATE]',
        // nonce: '[NONCE]',
        usePopup: true
      });
    })
  }

  show() {
    defer(() => window.AppleID?.auth, async () => {
      try {
        const data = await window.AppleID.auth.signIn();
        // Handle successful response.
        this.callback(data);
      } catch (error) {
        if (error?.error === "popup_closed_by_user") return;
        // Handle error.
        typeof this.onError === "function" && this.onError(error);
      }
    })
  }

  callback(data) {
    devLog(data);
    if (data?.authorization?.code) {
      typeof this.onSubmit === "function" && this.onSubmit(data.authorization.code);
    } else {
      typeof this.onError === "function" && this.onError(data);
    }
  }
}





